/* First-party acquisition evidence only. No Google/analytics sender.
 * A storefront witness is NOT final checkout permission. Imports stay blocked.
 */
(function () {
  'use strict';
  if (window.__velvenGoogleAcquisitionInstalled) return;
  window.__velvenGoogleAcquisitionInstalled = true;

  var KEY = 'velven_google_acquisition_v1';
  var ATTRIBUTE = '__vv_google_acquisition_v1__';
  var TTL = 90 * 24 * 60 * 60 * 1000;
  var POLICY = 'velven-au-default-2026-09-19';
  var landingConsumed = false;
  var inFlight = false;
  var dirty = false;
  var lastSent = null;
  var retryAt = 0;
  var privacyLoading = false;
  var expiryTimer;

  function permission() {
    try {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      var choices = api.currentVisitorConsent();
      var region = api.getRegion();
      var state = {
        at: new Date().toISOString(), source: 'shopify-customer-privacy-api',
        policy: POLICY, region: region,
        analytics: api.analyticsProcessingAllowed(), marketing: api.marketingAllowed(),
        saleOfData: api.saleOfDataAllowed(),
        choices: { analytics: choices.analytics, marketing: choices.marketing, saleOfData: choices.sale_of_data }
      };
      // Region is evidence, never a grant. Shopify's regional policy must allow
      // all three purposes AND explicit denial must be absent.
      if (typeof region !== 'string' || !/^[A-Z]{2}[A-Z0-9]{0,3}$/.test(region) || state.analytics !== true ||
          state.marketing !== true || state.saleOfData !== true) return null;
      if (![choices.analytics, choices.marketing, choices.sale_of_data].every(function (choice) {
        return choice === '' || choice === 'yes';
      })) return null;
      return state;
    } catch (_) { return null; }
  }

  function remove() {
    try { window.localStorage.removeItem(KEY); } catch (_) { /* No fallback storage. */ }
    window.clearTimeout(expiryTimer);
  }

  function validIds(ids) {
    if (!ids || typeof ids !== 'object') return false;
    var keys = Object.keys(ids);
    return keys.length > 0 && keys.every(function (key) {
      return ['gclid', 'gbraid', 'wbraid'].indexOf(key) !== -1 &&
        typeof ids[key] === 'string' && /^[A-Za-z0-9_-]{1,256}$/.test(ids[key]);
    });
  }

  function validWitness(state) {
    return state && state.source === 'shopify-customer-privacy-api' && state.policy === POLICY &&
      typeof state.region === 'string' && /^[A-Z]{2}[A-Z0-9]{0,3}$/.test(state.region) && state.analytics === true &&
      state.marketing === true && state.saleOfData === true && state.choices &&
      ['analytics', 'marketing', 'saleOfData'].every(function (key) {
        return state.choices[key] === '' || state.choices[key] === 'yes';
      });
  }

  function read() {
    try {
      var record = JSON.parse(window.localStorage.getItem(KEY));
      var captured = Date.parse(record.capturedAt);
      var expires = Date.parse(record.expiresAt);
      if (record.v !== 1 || !validIds(record.ids) || !validWitness(record.capturePermission) ||
          record.capturePermission.at !== record.capturedAt || !Number.isFinite(captured) ||
          captured > Date.now() || expires - captured !== TTL || expires <= Date.now()) throw new Error();
      // Reconstruct an allowlisted object: never forward arbitrary storage fields.
      return { v: 1, ids: Object.assign({}, record.ids), capturedAt: record.capturedAt,
        expiresAt: record.expiresAt, capturePermission: {
          at: record.capturePermission.at, source: record.capturePermission.source,
          policy: record.capturePermission.policy, region: record.capturePermission.region,
          analytics: true, marketing: true, saleOfData: true,
          choices: { analytics: record.capturePermission.choices.analytics,
            marketing: record.capturePermission.choices.marketing,
            saleOfData: record.capturePermission.choices.saleOfData }
        } };
    } catch (_) { remove(); return null; }
  }

  function capture(state) {
    if (landingConsumed) return null;
    landingConsumed = true;
    var params = new URLSearchParams(window.location.search);
    var ids = {};
    ['gclid', 'gbraid', 'wbraid'].forEach(function (key) {
      var values = params.getAll(key);
      // Reject ambiguous/invalid IDs rather than trimming, decoding or inventing one.
      if (values.length === 1 && /^[A-Za-z0-9_-]{1,256}$/.test(values[0])) ids[key] = values[0];
    });
    if (!validIds(ids)) return null;
    var record = { v: 1, ids: ids, capturedAt: state.at,
      expiresAt: new Date(Date.parse(state.at) + TTL).toISOString(), capturePermission: state };
    try { window.localStorage.setItem(KEY, JSON.stringify(record)); }
    catch (_) { return null; }
    return record;
  }

  function evidence() {
    var state = permission();
    if (!state) {
      // Never resurrect a denied landing when permission is subsequently granted.
      landingConsumed = true;
      remove();
      return '';
    }
    var record = read();
    if (record) landingConsumed = true;
    else record = capture(state);
    if (!record) return '';
    window.clearTimeout(expiryTimer);
    // setTimeout's signed-32-bit limit is shorter than 90 days.
    expiryTimer = window.setTimeout(sync, Math.min(2147483647, Date.parse(record.expiresAt) - Date.now()));
    return JSON.stringify({ v: 1, ids: record.ids, capturedAt: record.capturedAt,
      expiresAt: record.expiresAt, capturePermission: record.capturePermission,
      storefrontPermission: state, finalOrderPermission: 'unknown' });
  }

  function signature(value) {
    if (!value) return '';
    var parsed = JSON.parse(value);
    delete parsed.storefrontPermission.at;
    return JSON.stringify(parsed);
  }

  function sync() {
    if (privacyLoading) return;
    // Purge local state immediately on withdrawal, even during a pending write.
    var value = evidence();
    // Serialise writes so an in-flight grant is followed by the latest denial.
    if (inFlight) { dirty = true; return; }
    var sig = signature(value);
    if (sig === lastSent || Date.now() < retryAt || typeof window.fetch !== 'function') return;
    inFlight = true;
    var attributes = {};
    attributes[ATTRIBUTE] = value;
    var controller = new AbortController();
    var timeout = window.setTimeout(function () { controller.abort(); }, 5000);
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    window.fetch(root + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin', signal: controller.signal,
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).then(function (response) {
      if (response.ok) lastSent = sig;
      if (response.status === 429 || response.status === 503) {
        var seconds = Number(response.headers.get('Retry-After')) || 30;
        retryAt = Date.now() + Math.max(30, seconds) * 1000;
      }
      // No automatic retries. A later shopper event may retry after backoff.
    }).catch(function () { /* Never log identifiers or interfere with shopping. */ })
      .finally(function () {
        window.clearTimeout(timeout);
        inFlight = false;
        if (dirty) { dirty = false; sync(); }
      });
  }

  document.addEventListener('formdata', function (event) {
    if (!event.target || event.target.id !== 'vmcm-cart-form') return;
    // Native ordinary-cart serialization, no navigation interception or wait.
    event.formData.set('attributes[' + ATTRIBUTE + ']', evidence());
  });
  document.addEventListener('visitorConsentCollected', sync);
  document.addEventListener('cart:refresh', sync);
  window.addEventListener('pageshow', sync);
  window.addEventListener('focus', sync);
  window.addEventListener('storage', function (event) { if (event.key === KEY || event.key === null) sync(); });

  if (window.Shopify && window.Shopify.customerPrivacy) sync();
  else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    privacyLoading = true;
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      privacyLoading = false;
      if (error) { landingConsumed = true; remove(); }
      sync();
    });
  } else sync();
})();
